import { MediaObjectMapper } from './MediaObjectMapper.js';
import {
  BulkApiObject,
  BulkImageObject,
  BulkImageRefObject,
  StandardPhotoObject,
  MmbPhotosObject,
} from './media-adopter.interface.js';

export class MediaAdaptor {
  getStandardPhotoObject(
    source: string,
    photoObj: any,
    brand: string,
  ): StandardPhotoObject[] {
    return MediaObjectMapper.getStandardPhotoObject(source, photoObj, brand);
  }

  getUpdatedProxyUrl(
    host: string,
    assetRef: string,
    journals: string,
    height: number,
    brand: string,
  ): string {
    return MediaObjectMapper.getUpdatedProxyUrl(
      host,
      assetRef,
      journals,
      height,
      brand,
    );
  }

  getUpdatedHiresUrl(
    host: string,
    assetRef: string,
    journals: string,
    height: number,
    brand: string,
  ): string {
    return MediaObjectMapper.getUpdatedHiresUrl(
      host,
      assetRef,
      journals,
      height,
      brand,
    );
  }

  getBulkAPIUrl(
    host: string,
    userId: string,
    brand: string,
    reqPayload: string[],
  ): BulkApiObject {
    return MediaObjectMapper.getBulkAPIUrl(host, userId, brand, reqPayload);
  }

  getJournalMapping(
    journalList: string[],
    brand: string,
  ): { [key: string]: string } {
    return MediaObjectMapper.getJournalMapping(journalList, brand);
  }

  getStandardAlbumsResponse(albumsObject: any): any {
    return MediaObjectMapper.getStandardAlbumsResponse(albumsObject);
  }

  getAlbumMomentsResponse(momentsObject: any): any {
    return MediaObjectMapper.albumMomentsResponse(momentsObject);
  }

  getStandardPhotosResponse(albumMomentsObject: any): any {
    return MediaObjectMapper.standardPhotosResponse(albumMomentsObject);
  }

  getKrakenPhotoObject(albumMomentsObject: any, imgHost: string): any {
    return MediaObjectMapper.getKrakenPhotoObject(albumMomentsObject, imgHost);
  }

  getImageEditData(photoObj: any): {
    rotation: number;
    Crop?: string;
    Effect?: string;
  } {
    return MediaObjectMapper.getImageEditData(photoObj);
  }

  getAuroraBulkAPIUrl(
    host: string,
    userId: string,
    version: string,
    brand: string,
    reqPayload: string[],
  ): MmbPhotosObject {
    const payloadObject = { data: reqPayload };
    return MediaObjectMapper.getMmbPhotosUrl(
      host,
      userId,
      version,
      brand,
      payloadObject,
    );
  }

  getBulkImageUrl(
    host: string,
    userId: string,
    version: string,
    reqPayload: string[],
  ): BulkImageObject {
    return MediaObjectMapper.getBulkImageUrl(host, userId, version, reqPayload);
  }

  getBulkImageRefUrl(
    host: string,
    userId: string,
    version: string,
    reqPayload: Record<string, string>,
  ): BulkImageRefObject {
    return MediaObjectMapper.getBulkImageRefUrl(
      host,
      userId,
      version,
      reqPayload,
    );
  }

  getJournalCoreAPC(url: string): { [key: string]: string } {
    return MediaObjectMapper.getJournalCoreAPC(url);
  }
}

export default MediaAdaptor;
(window as any).mediaAdaptor = MediaAdaptor;
